import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { IconButton } from '@infoods/lifebase-ui';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';

import classes from './LbVerticalPageTabsList.module.scss';
import { TabOption, TabsConfig, TabValue } from '../types/TabsConfig';
import { useTabsContext } from '../context/TabsContext';

export type LbVerticalPageTabsListProps = {
  tabsConfig: TabOption[] | TabsConfig[];
  className?: string;
  children?: ReactNode;
};

export const LbVerticalPageTabsList = ({
  tabsConfig,
  className,
  children,
}: LbVerticalPageTabsListProps) => {
  const { value, onValueChange } = useTabsContext();

  const listClasses = classNames(className, classes.container);

  const handleTabClick = (tabValue: TabValue) => {
    onValueChange(tabValue);
  };

  return (
    <div className={listClasses} role="tablist">
      {tabsConfig.map(
        (tab) =>
          !tab.hide && (
            <div className={classes.tabWrapper} key={tab.value}>
              <button
                type="button"
                role="tab"
                aria-selected={value === tab.value}
                aria-controls={`panel-${tab.value}`}
                id={`tab-${tab.value}`}
                className={classNames(classes.tab, {
                  [classes.selected]: value === tab.value,
                })}
                disabled={tab.disabled}
                onClick={() => handleTabClick(tab.value)}
              >
                {!!tab.icon && <span className={classes.icon}>{tab.icon}</span>}
                <span>{tab.label}</span>
              </button>
              {!!tab.onDelete && (
                <IconButton
                  onClick={tab.onDelete}
                  size="medium"
                  color="secondary"
                  className={classes.deleteBtn}
                >
                  <ClearRoundedIcon />
                </IconButton>
              )}
            </div>
          ),
      )}
      {children && <div>{children}</div>}
    </div>
  );
};
